// extracted by mini-css-extract-plugin
export default {"container":"DeactivateField_container__3JTNg","checkboxes":"DeactivateField_checkboxes__E9Lr3"};